export default class StoreService {
  storageProvider;
  constructor(storageProvider) {
    this.storageProvider = storageProvider;
  }

  /**
   * Store value in underlying storage
   * @param {string} key Cache storage key
   * @param {object} value Value to store
   */
  setItem(key, value) {
    if (value)
      this.storageProvider.setItem(key, JSON.stringify(value));
  }

  /**
   * Get stored value from underlying storage
   * @param {string} key Cache storage key
   * @returns {object} Returns the current value associated with the key in underlying storage
   */
  getItem(key) {
    const value = this.storageProvider.getItem(key);
    if (value) {
      return JSON.parse(value);
    }
    return "";
  }

  /**
   * Remove value from underlying storage
   * @param {string} key Cache storage key
   */
  removeItem(key) {
    this.storageProvider.removeItem(key);
  }

  /**
   * Clear underlying storage
   */
  clear() {
    this.storageProvider.clear();
  }

  /**
   * preserveStorageKeys = ["key1", key2]
   *  preserve Storage Key and Clear underlying storage
   */
  clearAndPreserveStorageKey(preserveStorageKeys) {
    if (
      preserveStorageKeys !== null &&
      preserveStorageKeys !== undefined &&
      preserveStorageKeys.length > 0
    ) {
      for (let i = this.storageProvider.length - 1; i >= 0; i--) {
        const key = this.storageProvider.key(i);
        if (!preserveStorageKeys.includes(key)) {
          this.storageProvider.removeItem(key);
        }
      }
    } else {
      this.storageProvider.clear();
    }
  }
}
